import { createContext, useContext } from 'react';

// DOM node of the per-widget header-controls slot; null until the slot mounts (and for widgets
// rendered outside a card, e.g. AddWidget previews / Example components).
export const WidgetHeaderSlotContext = createContext<HTMLElement | null>(null);

export const useWidgetHeaderSlot = () => useContext(WidgetHeaderSlotContext);
